import React, { Fragment as F } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptopCode } from '@fortawesome/free-solid-svg-icons';
import '../../../styles/base.css';
import '../../../styles/bg.css';
import Pdf from '../../../assets/mateo-navarrete-resume-2023.pdf';

export const NewHeader = props => {
  return (
    <F>
      <div className="flex-center">
        <div id="bg" />
        <header id="header">
          <div className="logo">
            <FontAwesomeIcon
              icon={faLaptopCode}
              size="lg"
              className="fa-icon-logo"
            />
          </div>
          <div className="content">
            <div className="inner">
              <h1>Mateo Navarrete</h1>
              <p>FULL STACK WEB DEVELOPER WITH A PASSION FOR UI/UX.</p>
            </div>
          </div>
          <nav>
            <ul>
              <li>
                <a
                  rel="noopener noreferrer"
                  href="https://www.linkedin.com/in/mateonavarrete/"
                  target="blank"
                >
                  LinkedIn
                </a>
              </li>
              <li>
                <a
                  rel="noopener noreferrer"
                  href="https://github.com/mateo-navarrete"
                  target="blank"
                >
                  GitHub
                </a>
              </li>
              <li>
                <a
                  rel="noopener noreferrer"
                  href="https://www.npmjs.com/package/create-react-express-app"
                  target="blank"
                >
                  My Code
                </a>
              </li>
              <li>
                <a rel="noopener noreferrer" href={Pdf} target="blank">
                  Resume
                </a>
              </li>
            </ul>
          </nav>
        </header>
      </div>
    </F>
  );
};

